
<div class="accordion-container" :open="open" :bottomBorder="bottomBorder">
	<div class="accordion-header">
		<slot name="header" />
	</div>
	<div class="accordion-body-wrapper" :style="bodyStyle" @transitionend="$emit('transitionend')">
		<div ref="accBody" :open="open" class="accordion-body">
			<slot />
		</div>
	</div>
</div>
